<script lang="ts" setup>
import { useTranslate } from '@tolgee/vue'

import { useAccountStore } from '@/stores/Account'
import { usePublicData } from '@/stores/PublicData'
import { LANGUAGES, type LanguageType, PLAN_TYPES } from '@/api/interfaces'

import EditorSettings from '@/components/editor/EditorSettings.vue'
import EditorSettingsImpactColor from '@/components/editor/EditorSettingsImpactColor.vue'
import EditorSettingsImpactDisplay from '@/components/editor/EditorSettingsImpactDisplay.vue'
import EditorSettingsImpactStyle from '@/components/editor/EditorSettingsImpactStyle.vue'

const { t } = useTranslate('local')
const publicStore = usePublicData()
const accountStore = useAccountStore()

const items = {
  ...LANGUAGES.reduce(
    (acc, lang) => {
      acc[lang] = []
      return acc
    },
    {} as Record<LanguageType, []>,
  ),
  en: [
    {
      title: t.value('EditorImpactSettings.displayed.title'),
      component: EditorSettingsImpactDisplay,
    },
    {
      title: t.value('EditorImpactSettings.style.title'),
      description: t.value('EditorImpactSettings.style.description'),
      component: EditorSettingsImpactStyle,
    },
    {
      title: t.value('EditorImpactSettings.color.title'),
      component: EditorSettingsImpactColor,
      disabled: accountStore.hasStarterPlan,
    },
  ],
}
</script>

<template>
  <EditorSettings
    :items="items[publicStore.lang]"
    :plan-type="PLAN_TYPES.GROWTH"
    :title="t('EditorImpactSettings.title')"
  />
</template>

<style lang="scss" scoped></style>
